import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { deleteUserRequest } from 'actions';
import { fetchCottagesRequest } from 'actions/cottages';
import { data } from 'selectors/cottages';
import * as userSelector from 'selectors/user';
import DeleteAccountComponent from '../components/delete-account';

class DeleteAccountContainer extends React.Component {
  state = {
    opened: false,
  };

  componentDidMount() {
    this.props.fetchCottagesRequest();
  }

  setOpened = () => {
    this.setState({ opened: true });
  };

  setClosed = () => {
    this.setState({ opened: false });
  };

  onSubmit = async () => {
    this.props.deleteUserRequest();
  };

  render() {
    const { isLoading, cottages, success } = this.props;

    return (
      <>
        <DeleteAccountComponent
          success={success}
          cottages={cottages}
          opened={this.state.opened}
          isLoading={isLoading}
          setClosed={this.setClosed}
          setOpened={this.setOpened}
          onSubmit={this.onSubmit}
        />
      </>
    );
  }
}

DeleteAccountContainer.propTypes = {
  isLoading: PropTypes.bool,
  cottages: PropTypes.arrayOf(PropTypes.shape({})),

  deleteUserRequest: PropTypes.func.isRequired,
  fetchCottagesRequest: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
  success: PropTypes.shape({
    logout: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  isLoading: userSelector.isLoading(state),
  cottages: data(state),
  success: state.login.success,
});

const mapDispatchToProp = (dispatch) => ({
  deleteUserRequest: () => dispatch(deleteUserRequest()),
  fetchCottagesRequest: () => dispatch(fetchCottagesRequest()),
});

export default connect(mapStateToProps, mapDispatchToProp)(injectIntl(DeleteAccountContainer));
